import { render } from "./NavbarMain.vue?vue&type=template&id=1f08bd8e"
import script from "./NavbarMain.vue?vue&type=script&lang=js"
export * from "./NavbarMain.vue?vue&type=script&lang=js"

import "./NavbarMain.vue?vue&type=style&index=0&id=1f08bd8e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__